// Pure pricing + recommendation logic, computed live in the browser from the
// backend config. Prices are INDICATIVE; the firm figure is confirmed at signup.

export function fmtMoney(amount, currencyCode, currencies) {
  const c = currencies[currencyCode] || { symbol: "\u00a3", rate: 1 };
  const val = Math.round(amount * c.rate);
  return `${c.symbol}${val.toLocaleString()}`;
}

// Which modules are recommended from the confirmed assumptions, and why.
// The "why" always ties to a specific confirmed assumption.
export function recommendModules(a) {
  const rec = {}; // id -> reason string
  const rep = a.established_outside;

  if (rep && a.eu_residents && !a.has_eu_rep) {
    rec.eu_rep = "You process personal data of EU residents and are established outside the EU, so GDPR Article 27 needs an EU representative.";
  }
  if (rep && a.uk_residents && !a.has_uk_rep) {
    rec.uk_rep = "You process personal data of UK residents and are established outside the UK, so the UK GDPR needs a UK representative.";
  }
  if (rep && a.swiss_residents && !a.has_swiss_rep) {
    rec.swiss_rep = "You handle data of Swiss residents from outside Switzerland, which triggers a FADP Article 14 representative.";
  }
  if (a.uses_ai && a.eu_residents) {
    rec.eu_ai_rep = "You use AI or automated decisioning affecting users in the EU, so an EU AI Act representative is relevant.";
  }
  // Compliance Hub is the base of every representative plan.
  rec.hub = "Keeps your representative service, written agreements, requests and evidence in one place.";

  return rec;
}

// Compute the indicative monthly total from the selected monthly modules.
export function computePlan(selectedIds, modules, band, currencyCode, currencies) {
  let monthlyTotal = 0;
  const addons = [];
  const lines = [];

  selectedIds.forEach((id) => {
    const m = modules.find((x) => x.id === id);
    if (!m) return;
    if (m.priceModel === "monthly") {
      const amt = m.bands[band] ?? m.bands["SME"];
      monthlyTotal += amt;
      lines.push({ id, name: m.name, display: `${fmtMoney(amt, currencyCode, currencies)}/mo`, amount: amt });
    } else if (m.priceModel === "hourly") {
      addons.push({ id, name: m.name, display: `from ${fmtMoney(m.from, currencyCode, currencies)}/hr` });
      lines.push({ id, name: m.name, display: `from ${fmtMoney(m.from, currencyCode, currencies)}/hr`, amount: 0 });
    } else {
      addons.push({ id, name: m.name, display: "Custom" });
      lines.push({ id, name: m.name, display: "Custom", amount: 0 });
    }
  });

  const dual = selectedIds.includes("eu_rep") && selectedIds.includes("uk_rep");

  return {
    monthlyTotal,
    monthlyDisplay: fmtMoney(monthlyTotal, currencyCode, currencies),
    addons,
    lines,
    dual,
  };
}
